export default __webpack_public_path__ + "static/media/step_3.8ef1f852.svg";